import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiMicrosoftazure,
  SiGooglecloud,
  SiTerraform,
  SiSonarqube,
  SiPrometheus,
  SiGrafana,
  SiGnubash,
  SiArgo,
  SiTrivy,
  SiFalco,
} from "react-icons/si";
import { FaLinux, FaGithub, FaGitlab, FaJenkins } from "react-icons/fa";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Java from "../../Assets/TechIcons/Java.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Kubernates from "../../Assets/TechIcons/Kubernates.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import Go from "../../Assets/TechIcons/go.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import Node from "../../Assets/TechIcons/Node.svg";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Docker} alt="docker" />
        <div className="tech-icons-text">Docker</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Kubernates} alt="kubernetes" />
        <div className="tech-icons-text">Kubernetes</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaLinux />
        <div className="tech-icons-text">Linux</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={AWS} alt="AWS" className="tech-icon-images" />
        <div className="tech-icons-text">AWS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftazure />
        <div className="tech-icons-text">Azure</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglecloud />
        <div className="tech-icons-text">GCP</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Java} alt="Java" />
        <div className="tech-icons-text">Java</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Python} alt="Python" />
        <div className="tech-icons-text">Python</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="JavaScript" />
        <div className="tech-icons-text">JavaScript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="React" />
        <div className="tech-icons-text">ReactJs</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={SQL} alt="SQL" />
        <div className="tech-icons-text">SQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="Git" />
        <div className="tech-icons-text">Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaGithub />
        <div className="tech-icons-text">GitHub</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Postman} alt="Postman" />
        <div className="tech-icons-text">Postman</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Go} alt="Go" />
        <div className="tech-icons-text">Go</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="Tailwind CSS" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Node} alt="Node.js" />
        <div className="tech-icons-text">Node.js</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaGitlab />
        <div className="tech-icons-text">GitLab</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaJenkins />
        <div className="tech-icons-text">Jenkins</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiArgo />
        <div className="tech-icons-text">ArgoCD</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTerraform />
        <div className="tech-icons-text">Terraform</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGnubash />
        <div className="tech-icons-text">Bash Scripting</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSonarqube />
        <div className="tech-icons-text">SonarQube</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPrometheus />
        <div className="tech-icons-text">Prometheus</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGrafana />
        <div className="tech-icons-text">Grafana</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTrivy />
        <div className="tech-icons-text">Trivy</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFalco />
        <div className="tech-icons-text">Falco</div>
      </Col>
    </Row>
  );
}

export default Techstack;
